import { SourceLabel } from "stores/FindingStore";

import { GenericObject } from "utility/misc";

// -----------------------------------------------------------------------------

const COLORS = [
  "rgb(221, 235, 247)",
  "rgb(198, 219, 239)",
  "rgb(158, 202, 225)",
  "rgb(107, 174, 214)",
  "rgb(66, 146, 198)",
  "rgb(33, 113, 181)",
  "rgb(8, 81, 156)",
  "rgb(8, 48, 107)",
];

export default function getPieData(unresolvedBySource: GenericObject[] = []) {
  let pieData: PieDataProps[] = unresolvedBySource.map((v) => {
    return {
      id: SourceLabel[v.source],
      label: SourceLabel[v.source],
      value: v.count,
    };
  });

  if (pieData.length > 6) {
    const above = [];
    const below: PieDataProps[] = [];

    for (const v of pieData) {
      if (v.value <= 10) {
        below.push(v);
        continue;
      }
      above.push(v);
    }

    if (below.length > 1) {
      let otherCount = 0;
      for (const v of below) {
        otherCount += v.value;
      }

      above.push({
        id: "Other",
        label: "Other",
        value: otherCount,
      });

      pieData = above;
    }
  }

  pieData.map((v, i) => (v.color = COLORS[i % 8]));

  //
  return (pieData || []) as GenericObject[];
}

interface PieDataProps {
  id: string;
  label: string;
  value: number;
  color?: string;
}
